import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { setAppClient } from '@futuredev/shared-auth'
import './index.css'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'

setAppClient('admin');

(function() {
  const checkAndRedirect = (): boolean => {
    const currentUrl = window.location.href;
    if (currentUrl.includes('localhost:3001') || currentUrl.includes('127.0.0.1:3001')) {
      console.warn('[IMMEDIATE] Backend URL, redirecting to frontend...');
      const path = window.location.pathname;
      window.location.replace('http://localhost:5173' + (path === '/' ? '' : path));
      return true;
    }
    return false;
  };
  
  if (checkAndRedirect()) {
    return;
  }
  
  const interval = setInterval(() => {
    if (checkAndRedirect()) {
      clearInterval(interval);
    }
  }, 100);
  
  setTimeout(() => clearInterval(interval), 10000);
})();

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found');
  document.body.innerHTML = '<div style="padding: 20px; color: red; font-size: 24px;">Error: Root element not found. Make sure index.html has &lt;div id="root"&gt;&lt;/div&gt;</div>';
  throw new Error('Root element not found');
}

try {
  createRoot(rootElement).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>
  );
} catch (err: unknown) {
  console.error('render failed', err);
  rootElement.innerHTML = `
    <div style="padding: 20px; color: red; font-size: 18px; background: white; min-height: 100vh;">
      <h1 style="color: red;">Render Error</h1>
      <p><strong>Error:</strong> ${err instanceof Error ? err.message : 'Unknown error'}</p>
      <pre style="background: #f5f5f5; padding: 10px; overflow: auto; max-height: 400px;">${err instanceof Error ? err.stack : ''}</pre>
      <button onclick="window.location.reload()" style="padding: 10px 20px; margin-top: 20px; background: #0d1e2f; color: white; border: none; border-radius: 5px; cursor: pointer;">
        Reload Page
      </button>
    </div>
  `;
}
